import { gql } from '@apollo/client';

export const SUBMIT_SELF_APPLY = gql`
  mutation Mutation($onboardingForm: OnboardingForm!) {
    submitSelfApply(onboardingForm: $onboardingForm) {
      success
      message
    }
  }
`;
